// extracted by mini-css-extract-plugin
export default {"avater":"Avater_avater__kfDtv","avater__text":"Avater_avater__text__SyzIA"};